// Suffix timing also works while connecting to an older catalogue response.
export function modelTiming(model, cutoffs = {}) {
  const match = (model || '').match(/^(.*?)(?:-t-(\d+))?-(\d{1,2})\.(\d{2})-cutoff$/);
  return { base:match ? match[1] : model,
    leadDays:match ? Number(match[2] || 1) : 1,
    cutoff:cutoffs?.[model] || (match ? `${match[3].padStart(2,'0')}:${match[4]}` : '11:15') };
}
